import usePublicSettings from "../../lib/usePublicSettings";
import { useT } from "../../lib/i18n";

import { tr } from "../../lib/i18n";
export default function AboutPage() {
  const { t } = useT();
  const { settings } = usePublicSettings();
  return (
    <div className="public-container" data-testid="about-page" style={{ padding: "60px 20px 80px", maxWidth: 800 }}>
      <div className="section-eyebrow">{tr("x.our_story")}</div>
      <h1 className="section-title" style={{ fontSize: 40 }}>{t("about.title")}</h1>
      <div style={{ color: "var(--pub-ink-soft)", lineHeight: 1.7, fontSize: 16, whiteSpace: "pre-wrap" }}>
        {settings?.about_text || tr("x.we_re_get_in_touch_we_re_happy_to_help", { p0: settings?.showroom_name || "your local showroom" })}
      </div>

      {settings?.why_us_points?.length ? (
        <div style={{ marginTop: 40 }}>
          <h2 className="section-title" style={{ fontSize: 22 }}>{tr("x.why_us")}</h2>
          <div className="why-grid">
            {settings.why_us_points.map((p, i) => (
              <div key={i} className="why-card">
                <h4>{p.split(":")[0]}</h4>
                <p>{p.includes(":") ? p.split(":").slice(1).join(":").trim() : p}</p>
              </div>
            ))}
          </div>
        </div>
      ) : null}
    </div>
  );
}
